import axios from 'axios';
import config from './config';  // Adjust the path based on your project structure

export default axios.create({
    baseURL: config.apiBaseURL,
    withCredentials: true,
});